const VERY_HIGH = 'very_high';
const HIGH = 'high';
const MEDIUM = 'medium';
const LOW = 'low';
const INFO = 'info';

export const SEVERITIES = {
  VERY_HIGH,
  HIGH,
  MEDIUM,
  LOW,
  INFO
};

export const SEVERITY_COLORS = {
  [VERY_HIGH]: { color: 'var(--severityRed)' },
  [HIGH]: { color: 'var(--severityOrange)' },
  [MEDIUM]: { color: 'var(--severityYellow)' },
  [LOW]: { color: 'var(--severityBlue)' },
  [INFO]: { color: 'var(--zeroGrey)' }
};
